import React from "react";
import styled from "styled-components";

const FilterContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: center;
  margin: 20px 0;
`;

const FilterButton = styled.button`
  border: none;
  padding: 10px 14px;
  border-radius: 20px;
  cursor: pointer;
  font-size: 17px;
  transition: all 0.3s ease;

  ${(props) =>
    props.isActive
      ? `
      background-color: #7620FF;
      color: white;
    `
      : `
      background-color: white;
      color: #1f2937;
      border: 1px solid #e5e7eb;

      &:hover {
        background-color: #f3f4f6;
      }
    `}
`;

const FilterGroup = ({ categories, activeCategory, onCategoryChange }) => {
  return (
    <FilterContainer>
      {categories.map((category) => (
        <FilterButton
          key={category}
          onClick={() => onCategoryChange(category)}
          isActive={activeCategory === category}
        >
          {category}
        </FilterButton>
      ))}
    </FilterContainer>
  );
};

export default FilterGroup;
